// src/views/EventCreate.jsx
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Breadcrumb, Card, } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import {
  HomeOutlined,
  PlusOutlined,
  DeleteOutlined,
  UserAddOutlined,
  FileOutlined,
} from "@ant-design/icons";
import {
  Form,
  Input,
  DatePicker,
  Button,
  Select,
  Upload,
  message,
  Space,
  Divider,
  Card as AntCard,
} from "antd";
import { createEvent } from "@/api/eventApi";
import api from "@/api/api";
import "./EventCreate.css";

const { TextArea } = Input;

const EventCreate = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await api.get("/tasks/users");
      if (response.data.success) {
        setUsers(response.data.data || []);
      }
    } catch (err) {
      console.error("Error fetching users:", err);
      message.error("Foydalanuvchilarni yuklashda xatolik");
    }
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      // Prepare event data
      const eventData = {
        name: values.name,
        datetime: values.datetime.toISOString(),
        tasks: values.tasks || [],
      };

      // Add file if uploaded
      if (fileList.length > 0) {
        eventData.file = fileList[0].originFileObj;
      }

      await createEvent(eventData);
      message.success("Tadbir muvaffaqiyatli yaratildi!");
      navigate("/events/all");
    } catch (err) {
      console.error("Error creating event:", err);
      message.error(err.response?.data?.message || "Tadbir yaratishda xatolik");
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = ({ fileList: newFileList }) => {
    // Only keep the last file
    setFileList(newFileList.slice(-1));
  };

  const beforeUpload = (file) => {
    // Validate file size (max 10MB)
    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
      message.error("Fayl hajmi 10MB dan kichik bo'lishi kerak!");
      return false;
    }

    // Don't upload immediately, we'll handle it on submit
    return false;
  };

  return (
    <Container fluid className="p-4">
      {/* Breadcrumb */}
      <Breadcrumb>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
          <HomeOutlined />
        </Breadcrumb.Item>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/events/all" }}>
          Barcha tadbirlar
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Yangi tadbir yaratish</Breadcrumb.Item>
      </Breadcrumb>

      {/* <h2 className="mb-4 mt-3">Yangi event yaratish</h2> */}

      <Row>
        <Col xs={12} lg={8}>
          <Card>
            <Card.Body>
              <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                initialValues={{
                  tasks: [], // Tasks are now optional
                }}
              >
                {/* Event Name */}
                <Form.Item
                  label="Tadbir nomi"
                  name="name"
                  rules={[{ required: true, message: "Tadbir nomini kiriting!" }]}
                >
                  <Input size="middle" placeholder="Masalan: Yillik yig'ilish" />
                </Form.Item>

                {/* Event DateTime */}
                <Form.Item
                  label="Sana va vaqt"
                  name="datetime"
                  rules={[{ required: true, message: "Sana va vaqtni tanlang!" }]}
                >
                  <DatePicker
                    showTime
                    format="YYYY-MM-DD HH:mm"
                    size="middle"
                    style={{ width: "100%" }}
                    placeholder="Sana va vaqtni tanlang"
                  />
                </Form.Item>

                {/* File Upload */}
                <Form.Item label="Fayl biriktirish (ixtiyoriy)">
                  <Upload
                    fileList={fileList}
                    onChange={handleFileChange}
                    beforeUpload={beforeUpload}
                    maxCount={1}
                  >
                    <Button icon={<FileOutlined />}>Fayl tanlash</Button>
                  </Upload>
                  <small className="text-muted">Maksimal hajm: 10MB</small>
                </Form.Item>

                <Divider />

                {/* Tasks */}
                <h5 className="mb-3">
                  Topshiriqlar{" "}
                  <small className="text-muted">(ixtiyoriy)</small>
                </h5>
                <p className="text-muted" style={{ fontSize: "14px", marginTop: "-8px" }}>
                  Tadbir uchun topshiriqlar qo'shishingiz yoki topshiriqsiz e'lon yaratishingiz mumkin
                </p>

                <Form.List name="tasks">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }, index) => (
                        <AntCard
                          key={key}
                          className="mb-3"
                          title={`Topshiriq ${index + 1}`}
                          extra={
                            fields.length > 1 ? (
                              <Button
                               size="middle"
                                type="text"
                                danger
                                icon={<DeleteOutlined />}
                                onClick={() => remove(name)}
                              >
                                O'chirish
                              </Button>
                            ) : null
                          }
                        >
                          <Form.Item
                            {...restField}
                            label="Topshiriq nomi"
                            name={[name, "title"]}
                            rules={[
                              { required: true, message: "Topshiriq nomini kiriting!" },
                            ]}
                          >
                            <Input  size="middle" placeholder="Masalan: Hisobot tayyorlash" />
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            label="Tavsif"
                            name={[name, "description"]}
                          >
                            <TextArea
                              rows={3}
                              placeholder="Topshiriq haqida qo'shimcha ma'lumot"
                            />
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            label="Foydalanuvchilar (ixtiyoriy)"
                            name={[name, "user_ids"]}
                          >
                            <Select
                             size="middle"
                              mode="multiple"
                              placeholder="Foydalanuvchilarni tanlang"
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              options={users.map((user) => ({
                                value: user.id,
                                label: user.name || `${user.first_name} ${user.surname}`,
                              }))}
                            />
                          </Form.Item>
                        </AntCard>
                      ))}

                      <Form.Item>
                        <Button
                         size="middle"
                          type="dashed"
                          onClick={() =>
                            add({ title: "", description: "", user_ids: [] })
                          }
                          block
                          icon={<PlusOutlined />}
                        >
                          Topshiriq qo'shish
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>

                <Divider />

                {/* Submit Buttons */}
                <Form.Item>
                  <Space>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={loading}
                      size="middle"
                      icon={<PlusOutlined />}
                    >
                      Tadbir yaratish
                    </Button>
                    <Button
                      size="middle"
                      onClick={() => navigate("/events/all")}
                    >
                      Bekor qilish
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} lg={4}>
          <Card>
            <Card.Body>
              <h5 className="mb-3">Ko'rsatmalar</h5>
              <ul className="text-muted" style={{ fontSize: "14px" }}>
                <li>Tadbir nomini aniq va tushunarli yozing</li>
                <li>Sana va vaqtni to'g'ri belgilang</li>
                <li>
                  <strong>Yangilik:</strong> Topshiriqsiz tadbir yaratish mumkin (e'lonlar uchun)
                </li>
                <li>Kerak bo'lsa topshiriqlar qo'shing va javobgar foydalanuvchilarni tayinlang</li>
                <li>Fayl biriktirish ixtiyoriy (maksimal 10MB)</li>
                <li>Bir tadbirga bir nechta topshiriq qo'shishingiz mumkin</li>
              </ul>

              <Divider />

              <h5 className="mb-3">Foydalanuvchilar: {users.length} ta</h5>
              <p className="text-muted" style={{ fontSize: "14px" }}>
                Sizga tayinlangan foydalanuvchilar ro'yxatidan tanlashingiz mumkin.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default EventCreate;
